export const LINE_SIZE = 78

// Horizontal line between sections
export const HORIZONTAL_LINE = '\u2500'.repeat(LINE_SIZE)

// Full blocks filling lower|upper half of the line
export const FULL_LOWER_LINE = '\u2584'.repeat(LINE_SIZE)
export const FULL_UPPER_LINE = '\u2580'.repeat(LINE_SIZE)

// Long dash character
export const SEPARATOR = ' \u2500\u2500 '
